import React, { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import Simulateur96 from "../simulateur.A2.18/simulateur.A2.18";
import Simulateur97 from "../simulateur.A2.19/simulateur.A2.19";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import SelectDepartement from "../../../components/selects/select.departement";
import Simulateur92 from "../simulateur.A1.12PRO/simulateur.A1.12PRO";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import {ToolTipPerso} from "../../../components/selects/tooltip_perso";

// Acquisition de biens et droits immobiliers par tous professionnels assujettis à la TVA, (terrains à bâtir ou non, constructions achevées depuis plus de 5 ans) TVA sur le prix total si TVA déduite lors de l'acquisition, TPF réduite -Art 1594 F quinquies-, engagement de revendre dans les 5 ans -CGI Art 1115-)
// simulateur id 6

function Simulateur_A2_8(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [promesse, setPromesse] = useState(0);
  const [pretHypo, setPretHypo] = useState(0);
  const [sansGarantieHypo, setSansGarantieHypo] = useState(0);
  const [avecGarantieHypo, setAvecGarantieHypo] = useState(0);
  const [simu96, setSimu96] = useState(null);
  const [simu92, setSimu92] = useState(null);
  const currentIdSimu = 6;
  const [simu97, setSimu97] = useState(null);
  const [montantVente, setMontantVente] = useState(0);
  const [montantPromesse, setMontantPromesse] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [dependances, setDependancesState] = useState([]);
  const [dep1, setDep1] = useState({});

  const handleChange = async (setter, value) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value);
  };

  useEffect(() => {
    if (simu96 !== undefined && simu96 !== null) setDependances(simu96);
  }, [simu96]);

  useEffect(() => {
    if (simu92 !== undefined && simu92 !== null) setDependances(simu92);
  }, [simu92]);

  useEffect(() => {
    if (simu97 !== undefined && simu97 !== null) setDependances(simu97);
  }, [simu97]);

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setDependances(simu) {
    setInRedux("dependance", simu);
  }

  function setInRedux(setter, value) {
    let object = {
      simulateurid: currentIdSimu,
      departementid: 0,
      inputs: {},
      dependances: [],
    };

    if (setter === setPretHypo) {
      if (value === 0) {
        setSimu92(null);
        setSimu96(null);
        setSimu97(null);
        setDependancesState([]);
        Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
        Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
        Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
        Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
        Object.assign(object["inputs"], { promesse: parseInt(promesse) });
        object.dependances = [];
        object.departementid = parseInt(departement);
      } else {
        Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
        Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
        Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
        Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
        Object.assign(object["inputs"], { promesse: parseInt(promesse) });
        object.dependances = dependances;
        object.departementid = parseInt(departement);
      }
    }

    if (setter === setSansGarantieHypo) {
      if (value === 0) {
        const index = dependances.findIndex((obj) => obj.simulateurid === 96);
        dependances?.splice(index, 1);
        setSimu96(null);
      }
      Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
      Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
      Object.assign(object["inputs"], { promesse: parseInt(promesse) });
      object.dependances = dependances;
      object.departementid = parseInt(departement);
    }

    if (setter === setAvecGarantieHypo) {
      if (value === 0) {
        const index = dependances.findIndex((obj) => obj.simulateurid === 97);
        dependances?.splice(index, 1);
        setSimu97(null);
      }
      Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
      Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
      Object.assign(object["inputs"], { promesse: parseInt(promesse) });
      object.dependances = dependances;
      object.departementid = parseInt(departement);
    }

    if (setter === "dependance") {
      if (dependances.length > 0) object.dependances = dependances;

      if (value !== undefined) {
        let validator = false;

        for (let i = 0; i < object["dependances"].length; i++) {
          if (object["dependances"][i]?.simulateurid === value.simulateurid) {
            object.dependances[i] = value;
            validator = true;
          }
        }

        if (validator === false) {
          object.dependances.push(value);
        }

        setDependancesState(object.dependances);

        Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
        Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
        Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
        Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
        Object.assign(object["inputs"], { promesse: parseInt(promesse) });
        object.departementid = parseInt(departement);
      }
    }

    if (setter === setMontantVente) {
      Object.assign(object["inputs"], { montant_vente: parseInt(value) });
      Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
      Object.assign(object["inputs"], { promesse: parseInt(promesse) });
      object.dependances = dependances;
      object.departementid = parseInt(departement);
    }

    if (setter === setMontantPromesse) {
      Object.assign(object["inputs"], { montant_promesse: parseInt(value) });
      Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
      Object.assign(object["inputs"], { promesse: parseInt(promesse) });
      object.dependances = dependances;
      object.departementid = parseInt(departement);
    }

    if (setter === setMontantDeboursAdditionnels) {
      Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
      Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
      Object.assign(object["inputs"], { promesse: parseInt(promesse) });
      object.dependances = dependances;
      object.departementid = parseInt(departement);
    }

    if (setter === setDepartement) {
      Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
      Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
      Object.assign(object["inputs"], { promesse: parseInt(promesse) });
      object.dependances = dependances;
      object.departementid = parseInt(value);
    }

    if (setter === setDeboursAdditionnels) {
      Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
      Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
      Object.assign(object["inputs"], { promesse: parseInt(promesse) });
      object.dependances = dependances;
      object.departementid = parseInt(departement);
    }

    if (setter === setPromesse) {
      Object.assign(object["inputs"], { montant_promesse: parseInt(montantPromesse) });
      Object.assign(object["inputs"], { montant_vente: parseInt(montantVente) });
      Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
      Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
      Object.assign(object["inputs"], { promesse: parseInt(value) });
      object.dependances = dependances;
      object.departementid = parseInt(departement);
    }

    if (props.isParent) {
      dispatch(setSimulateurObject(object));
    } else {
    }
  }

  const depsTaxeIleFrance = [75, 77, 78, 91, 92, 93, 94, 95];
  const depsZrr = [14, 38, 51, 71];

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Pour la vente, acte tarifé au titre du Tableau 5, n° 54 (Art A444-91). Prêt aux professionnels associé acte
          tarifé au titre du Tableau 5, n° 128 (Art A444-139). Cautionnement associé acte tarifé au titre du Tableau 5,
          n° 111 (Art A444-127).
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quel est le montant de la vente ?</div>

          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantVente}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il une promesse de vente reçue sous forme authentique :
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setPromesse} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>
        {parseInt(promesse) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer le montant HT des honoraires de rédaction (s'il y a lieu) :
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantPromesse}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il des débours additionnels à prévoir ?
            <ToolTipPerso
                title={
                  "Les débours sur les ventes comprennent une somme de 120 euros représentant le coût moyen d'obtention d'un certificat d'urbanisme complet. Pour retirer ce coût, répondre 'non' à la question."
                }
            />
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setDeboursAdditionnels} fieldUndefined={true} defaultValue={2} />
          </div>
        </div>

        {parseInt(deboursAdditionnels) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Montant des débours additionnels :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantDeboursAdditionnels}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Y'a-t-il un prêt hypothécaire ?</div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setPretHypo} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {parseInt(pretHypo) === 1 ? (
          <>
            <Simulateur92
              // simulateur={props.simulateur}
              // isParent={false}
              // departements={departements}
              contentDep={setDep1}
              simulateur={props.simulateur}
              isParent={false}
              departementId={departement}
              dependances={setSimu92}
            />

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Y'a-t-il un cautionnement sans garantie hypothécaire ?</div>
              <div>
                <ButtonYesno
                  handleChange={handleChange}
                  setter={setSansGarantieHypo}
                  fieldUndefined={false}
                  defaultValue={0}
                />
              </div>
            </div>

            {parseInt(sansGarantieHypo) === 1 ? (
              <>
                <Simulateur96
                  simulateur={props.simulateur}
                  isParent={false}
                  departementId={departement}
                  dependances={setSimu96}
                />
              </>
            ) : (
              <></>
            )}

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Y'a-t-il un cautionnement avec garantie hypothécaire ?</div>
              <div>
                <ButtonYesno
                  handleChange={handleChange}
                  setter={setAvecGarantieHypo}
                  fieldUndefined={false}
                  defaultValue={0}
                />
              </div>
            </div>

            {parseInt(avecGarantieHypo) === 1 ? (
              <>
                <Simulateur97
                  simulateur={props.simulateur}
                  isParent={false}
                  departementId={departement}
                  dependances={setSimu97}
                />
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default Simulateur_A2_8;
